import { useFlag } from '@unleash/proxy-client-react';

import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import {
  Box, Button,
  Drawer,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationButton from '../../../Common/NotificationButton';
import SwContext from '../../Contexts/SwContext';
import useLiveContext from '../../LiveContext/useLiveContext';
import ListeningIndicator from './Components/ListeningIndicator';
import ProjectButton from './Components/ProjectButton';
import SideMenu from './Components/SideMenu';
import StyledBox from './styles';

export default function Header() {
  const [openMenu, setOpenMenu] = React.useState<boolean>(false);
  const { sessionState: { session } } = useLiveContext();
  const { needRefresh, refresh } = React.useContext(SwContext);
  const { t } = useTranslation();
  const flag = useFlag('webapp-notifications');

  React.useEffect(() => {
    if (!session?.id && needRefresh) {
      refresh();
    }
  }, [session, needRefresh]);

  return (
    <StyledBox>
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="left" keepMounted={false}>
        <SideMenu
          onClose={() => { setOpenMenu(false); }}
        />
      </Drawer>
      <Button onClick={() => { setOpenMenu(true); }}>
        <MenuRoundedIcon />
      </Button>
      <Box>
        <ProjectButton />
        {session?.id && <ListeningIndicator sessionId={session.id} />}
      </Box>
      <Box>
        {needRefresh ? (
          <Button className="reload" onClick={() => { refresh(); }}>
            {t('reload')}
          </Button>
        ) : <div />}
        {flag && (
          <NotificationButton />
        )}
      </Box>
    </StyledBox>
  );
}
